<template>
  <div class="content">
    <title-bar :title="$lang.bonus_title3"> </title-bar>
    <!-- <div style="margin-left: 10px; margin-right: 10px; margin-top: 10px">
      <img
        src="../../../assets/img/bonus/bonus5.png"
        width="100%"
        style="position: relative; border-radius: 13px"
      />
    </div> -->
    <!-- <div style="position: relative; margin: 10px 10px 0 10px">
      <img
        src="../../../assets/img/bonus/bonus5.png"
        width="100%"
        style="border-radius: 13px"
      />
      <div style="position: absolute; top: 20px; left: 20px">
        <p
          style="font-weight: 800; font-size: var(--vk-fs-15); margin-bottom: 10px"
          v-html="$lang.common_txt228"
        ></p>
        <p v-html="$lang.common_txt229"></p>
      </div>
    </div> -->
    <div class="content-c">
      <div class="content-c--c">
        <p class="content-c--c1">{{ $lang.bonus_txt6 }}</p>
        <p class="content-c--c2 font-color">
          {{ $lang.Obter }}
          <span style="font-size: var(--vk-fs-lg)" class="info-color m-l-5">
            {{ info.reliefAmount }}
          </span>
          {{ $lang.bonus_txt7 }}
        </p>
        <van-button
          size="large"
          class="custom-button"
          :class="{ active: info.promoStatus !== 'not_receive' }"
          :disabled="claiming || info.promoStatus !== 'not_receive'"
          @click="getJl"
        >
          {{ claiming ? ($lang.common_loading || 'Loading...') : $lang.Receber }}
        </van-button>
        <img
          class="content-c--c5"
          src="../../../assets/img/bonus/loss_rebate.png"
        />
      </div>
      <div
        class="content-c2--c2t"
        style="font-weight: bold; font-size: var(--vk-fs-md); margin: 15px 5px"
      >
        {{ $lang.bonus_txt8 }}
      </div>
      <div class="content-c3">
        <div class="content-c3--t font-color">
          <p>{{ $lang.bonus_txt9 }}</p>
          <p>{{ $lang.bonus_txt10 }}</p>
        </div>
        <div
          class="content-c3--t2"
          v-for="(item, index) in InitDate"
          :key="index"
          :style="(index + 1) % 2 === 0 ? {} : { backgroundColor: '#454654' }"
        >
          <p style="font-weight: bold">{{ item.minAmount }}</p>
          <p style="font-weight: bold">{{ item.percent }}</p>
        </div>
      </div>
      <van-loading v-if="loading" color="#ff5a1f" vertical> </van-loading>
      <div v-if="readError" class="read-error">{{ readError }}</div>

      <div
        class="d-flex f-t-15 f-w m-t-10 m-b-10"
        style="justify-content: center"
      >
        <span class="share-bot-l"></span>
        <span>{{ $lang.common_txt35 }}</span>
        <span class="share-bot-r"></span>
      </div>
      <div
        class="font-color"
        v-html="$lang.bonus_txt11"
        style="line-height: 20px"
      ></div>
    </div>
  </div>
</template>
<script>
import { GetPromoDailyRelief, ReceivePromoReliefAmount } from '@/api/common'
import {
  failMessage as rewardFailMessage,
  hasRewardIssueProof,
  hasUnavailableMarker,
  isRewardClaimSuccessWithProof as rewardClaimSuccess,
  isNeedLogin,
  isOkResponse,
  responseContent
} from '../activity/rewardApi'
// Legacy h5-bonus-claim contract name: isClaimSuccess as rewardClaimSuccess.
export default {
  name: 'cashBack',
  components: {},
  data() {
    return {
      InitDate: [],
      info: {
        reliefAmount: 0,
        promoStatus: ''
      },
      loading: false,
      claiming: false,
      readError: ''
    }
  },
  mounted() {
    if (this.token) {
      this.GetPromoDailyRelief()
    } else {
      this.requireLogin()
    }
  },
  methods: {
    requireLogin() {
      if (this.$bus) this.$bus.$emit('openLogin')
    },
    isRewardNeedLogin(res) {
      if (isNeedLogin(res)) return true
      const stack = [res]
      for (let i = 0; i < stack.length; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (body.need_login === true || body.needLogin === true || [body.status, body.state, body.code, body.errorCode, body.need_login, body.needLogin].some(value => String(value || '').trim().toLowerCase() === 'need_login')) return true
        ;['content', 'data', 'page', 'extra', 'payload', 'body'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    unavailableToken(value) {
      return String(value == null ? '' : value).trim().toLowerCase()
    },
    isRewardUnavailableValue(value) {
      const token = this.unavailableToken(value)
      return value === true || [
        'mock',
        'fallback',
        'mock_fallback',
        'mock-fallback',
        'mock fallback',
        'stub',
        'read_only',
        'read_only_mode',
        'readonlymode',
        'read only mode',
        'read-only-mode',
        'read_only_reward',
        'readonlyreward',
        'read only reward',
        'read-only-reward',
        'read_only_action',
        'readonlyaction',
        'read only action',
        'read-only-action',
        'readonly',
        'read only',
        'read-only',
        'unimplemented',
        'not_implemented',
        'not_supported',
        'not supported',
        'not implemented',
        'dataunavailable',
        'data_unavailable',
        'data unavailable',
        'readunavailable',
        'read_unavailable',
        'read unavailable',
        'readblocked',
        'read_blocked',
        'read blocked',
        'technicalmarker',
        'technical_marker',
        'backendfailure',
        'backend_failure',
        'need_login',
        'need login',
        'need-login',
        'write_blocked',
        'writeblocked',
        'write blocked',
        'write-blocked',
        'backend_blocked',
        'backendblocked',
        'backend blocked',
        'backend-blocked',
        'reward_backend_blocked',
        'rewardbackendblocked',
        'reward backend blocked',
        'reward-backend-blocked',
        'unsupported',
        'disabled'
      ].includes(token) ||
        token.includes('mock') ||
        token.includes('mock_mode') ||
        token.includes('mock mode') ||
        token.includes('mock-mode') ||
        token.includes('fallback') ||
        token.includes('read_only') ||
        token.includes('readonlymode') ||
        token.includes('read only mode') ||
        token.includes('read-only-mode') ||
        token.includes('read_only_reward') ||
        token.includes('readonlyreward') ||
        token.includes('read only reward') ||
        token.includes('read-only-reward') ||
        token.includes('read_only_action') ||
        token.includes('readonlyaction') ||
        token.includes('read only action') ||
        token.includes('read-only-action') ||
        token.includes('read only') ||
        token.includes('read-only') ||
        token.includes('unimplemented') ||
        token.includes('not_implemented') ||
        token.includes('not_supported') ||
        token.includes('not supported') ||
        token.includes('not implemented') ||
        token.includes('dataunavailable') ||
        token.includes('data_unavailable') ||
        token.includes('data unavailable') ||
        token.includes('readunavailable') ||
        token.includes('read_unavailable') ||
        token.includes('read unavailable') ||
        token.includes('readblocked') ||
        token.includes('read_blocked') ||
        token.includes('read blocked') ||
        token.includes('technicalmarker') ||
        token.includes('technical_marker') ||
        token.includes('backendfailure') ||
        token.includes('backend_failure') ||
        token.includes('need_login') ||
        token.includes('need login') ||
        token.includes('need-login') ||
        token.includes('write_blocked') ||
        token.includes('writeblocked') ||
        token.includes('write blocked') ||
        token.includes('write-blocked') ||
        token.includes('backend_blocked') ||
        token.includes('backendblocked') ||
        token.includes('backend blocked') ||
        token.includes('backend-blocked') ||
        token.includes('reward_backend_blocked') ||
        token.includes('rewardbackendblocked') ||
        token.includes('reward backend blocked') ||
        token.includes('reward-backend-blocked') ||
        token.includes('unsupported')
    },
    hasRewardUnavailableMarker(res) {
      if (hasUnavailableMarker(res)) return true
      const stack = [res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach(value => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const flags = [
          body.readOnly,
          body.readOnlyMode,
          body.read_only_mode,
          body.readOnlyReward,
          body.read_only_reward,
          body.readOnlyAction,
          body.read_only_action,
          body.read_only,
          body.mock_fallback,
          body.not_implemented,
          body.not_supported,
          body.need_login,
          body.needLogin,
          body.notSupported,
          body.unsupported,
          body.technicalError,
          body.technical_error,
          body.technicalMarker,
          body.technical_marker,
          body.technicalException,
          body.technical_exception,
          body.backendFailure,
          body.backend_failure,
          body.fallback,
          body.dataUnavailable,
          body.data_unavailable,
          body.readUnavailable,
          body.read_unavailable,
          body.writeBlocked,
          body.readBlocked,
          body.read_blocked,
          body.backendBlocked,
          body.backend_blocked,
          body.rewardBackendBlocked,
          body.reward_backend_blocked,
          body.falseProof,
          body.false_proof,
          body.failClosed,
          body.fail_closed,
          body.unimplemented,
          body.failed,
          body.readonly,
          body.notImplemented,
          body.stub,
          body.mock,
          body.mockMode,
          body.mock_mode,
          body.mockFallback,
          body.write_blocked,
          body.paymentStatusUnconfirmed,
          body.payment_status_unconfirmed
        ]
        if (flags.some(value => this.isRewardUnavailableValue(value))) return true
        const proofValues = [
          body.writeProof,
          body.write_proof,
          body.rewardProof,
          body.reward_proof,
          body.orderProof,
          body.order_proof,
          body.affectedProof,
          body.affected_proof,
          body.serverProof,
          body.server_proof
        ]
        if (proofValues.some((value) => {
          const token = this.unavailableToken(value)
          return value === false || value === 0 || token === 'false' || token === '0' || token === 'fail' || token === 'failed'
        })) return true
        const values = [
          ...flags,
          body.msg,
          body.message,
          body.reason,
          body.desc,
          body.description,
          body.errorMsg,
          body.errorMessage,
          body.detail,
          body.readOnlyMessage,
          body.unavailableReason
        ]
        const markers = ['未接入', 'mock', 'mockMode', 'mock_mode', 'fallback', 'dataUnavailable', 'data unavailable', 'data_unavailable', 'readUnavailable', 'read unavailable', 'read_unavailable', 'readBlocked', 'read blocked', 'read_blocked', 'stub', '只读', 'readOnlyMode', 'read_only_mode', 'readOnlyReward', 'read_only_reward', 'readOnlyAction', 'read_only_action', '阻止假成功', 'writeBlocked', 'paymentStatusUnconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'writeProof', 'write_proof', 'writeProof:false', 'write_proof:false', 'falseProof', 'false_proof', 'false proof', 'failClosed', 'fail_closed', 'fail closed', 'backendBlocked', 'rewardBackendBlocked', 'backend_blocked', 'reward_backend_blocked', 'backendFailure', 'backend_failure', 'technicalException', 'technical_exception', 'technical exception', 'technicalError', 'technical_error', 'technical error', 'technicalMarker', 'technical_marker', 'not_implemented', 'not_supported', 'not supported', 'need_login', 'need login', 'need-login', 'unsupported', 'unimplemented', 'failed']
        if (values.some((value) => {
          if (value === true || value === 1) return true
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && markers.some((marker) => token.includes(String(marker).toLowerCase()))
        })) return true
        if ([body.status, body.state, body.result, body.code, body.errorCode, body.paymentStatusUnconfirmed, body.payment_status_unconfirmed, body.paymentStatus, body.payment_status, body.rewardStatus, body.reward_status].some(value => this.isRewardUnavailableValue(value))) return true
        if ([body.success, body.receiveSuccess, body.claimSuccess].some(value => value === false || this.unavailableToken(value) === 'false')) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    hasBlockingReadFailureMarker(res) {
      const stack = [res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach(value => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const hardReadFlags = [
          body.readUnavailable,
          body.read_unavailable,
          body.readBlocked,
          body.read_blocked,
          body.backendBlocked,
          body.backend_blocked,
          body.rewardBackendBlocked,
          body.reward_backend_blocked,
          body.technicalError,
          body.technical_error,
          body.technicalMarker,
          body.technical_marker,
          body.technicalException,
          body.technical_exception,
          body.backendFailure,
          body.backend_failure
        ]
        if (hardReadFlags.some(value => this.isRewardUnavailableValue(value))) return true
        const values = [
          ...hardReadFlags,
          body.msg,
          body.message,
          body.reason,
          body.desc,
          body.description,
          body.errorMsg,
          body.errorMessage,
          body.detail,
          body.unavailableReason
        ]
        const markers = ['readUnavailable', 'read unavailable', 'read_unavailable', 'readBlocked', 'read blocked', 'read_blocked', 'backendBlocked', 'backend blocked', 'backend_blocked', 'rewardBackendBlocked', 'reward backend blocked', 'reward_backend_blocked', 'backendFailure', 'backend failure', 'backend_failure', 'technicalException', 'technical exception', 'technical_exception', 'technicalError', 'technical error', 'technical_error', 'technicalMarker', 'technical marker', 'technical_marker']
        if (values.some((value) => {
          if (value === true || value === 1) return true
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && markers.some((marker) => token.includes(String(marker).toLowerCase()))
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'error', 'errors', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    safeRuleList(value) {
      if (Array.isArray(value)) return value
      if (!value) return []
      try {
        const parsed = JSON.parse(value)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    },
    failMessage(res, fallback) {
      return rewardFailMessage(res, fallback || this.$lang.mc_claim_failed || 'Reward is temporarily unavailable. Please try again later.')
    },
    firstValue(...values) {
      return values.find(value => value !== undefined && value !== null && value !== '')
    },
    safeNumber(value, fallback = 0) {
      const n = Number(typeof value === 'string' ? value.replace(/,/g, '') : value)
      return Number.isFinite(n) ? n : fallback
    },
    normalizedReadBody(content) {
      const c = content || {}
      if (this.firstValue(
        c.reliefAmount,
        c.relief_amount,
        c.amount,
        c.availableAmount,
        c.amountAvailable,
        c.rebateAmount,
        c.rewardAmount,
        c.promoStatus,
        c.status,
        c.receiveStatus,
        c.receive_status,
        c.claimStatus,
        c.claim_status
      ) !== undefined) return c
      const nested = this.firstValue(c.info, c.detail, c.details)
      if (nested && typeof nested === 'object' && !Array.isArray(nested)) return nested
      const row = this.firstValue(
        Array.isArray(c.records) ? c.records[0] : null,
        Array.isArray(c.list) ? c.list[0] : null,
        Array.isArray(c.dataList) ? c.dataList[0] : null,
        Array.isArray(c.items) ? c.items[0] : null
      )
      if (row && typeof row === 'object') return row
      return c
    },
    normalizedPromoStatus(c) {
      return this.firstValue(
        c.promoStatus,
        c.status,
        c.receiveStatus,
        c.receive_status,
        c.claimStatus,
        c.claim_status,
        c.state
      )
    },
    normalizedRuleList(content) {
      const c = content || {}
      const body = this.normalizedReadBody(c)
      return this.safeRuleList(this.firstValue(
        body.ruleList,
        body.rules,
        body.promoRuleList,
        body.list,
        body.records,
        body.dataList,
        c.ruleList,
        c.rules,
        c.promoRuleList,
        c.list,
        c.records,
        c.dataList
      ))
    },
    isReadableInitResponse(res) {
      const statusToken = String(this.firstValue(res && res.status, res && res.state, res && res.result, res && res.code, res && res.errorCode, res && res.success) || '').trim().toLowerCase()
      if (!isOkResponse(res) && !['ok', 'success', 'succeeded', 'true', '1', '0'].includes(statusToken) && !this.hasRewardUnavailableMarker(res)) return false
      const content = responseContent(res)
      const body = this.normalizedReadBody(content)
      return this.firstValue(
        body.reliefAmount,
        body.relief_amount,
        body.amount,
        body.availableAmount,
        body.amountAvailable,
        body.rebateAmount,
        body.rewardAmount,
        body.promoStatus,
        body.status,
        body.receiveStatus,
        body.receive_status,
        body.claimStatus,
        body.claim_status,
        body.ruleList,
        body.rules,
        body.promoRuleList,
        body.list,
        body.records,
        body.dataList,
        content.ruleList,
        content.rules,
        content.promoRuleList,
        content.list,
        content.records,
        content.dataList
      ) !== undefined
    },
    normalizeInfo(content, source) {
      const c = content || {}
      const body = this.normalizedReadBody(c)
      const disabled = this.hasRewardUnavailableMarker(source || c) ||
        this.hasRewardUnavailableMarker(c) ||
        this.hasRewardUnavailableMarker(body) ||
        body.rewardWritable === false ||
        String(body.rewardWritable).trim().toLowerCase() === 'false' ||
        body.writeEnabled === false ||
        String(body.writeEnabled).trim().toLowerCase() === 'false' ||
        c.rewardWritable === false ||
        String(c.rewardWritable).trim().toLowerCase() === 'false' ||
        c.writeEnabled === false ||
        String(c.writeEnabled).trim().toLowerCase() === 'false'
      const promoStatus = this.normalizedPromoStatus(body)
      return {
        ...c,
        ...body,
        reliefAmount: this.safeNumber(this.firstValue(
          body.reliefAmount,
          body.relief_amount,
          body.amount,
          body.availableAmount,
          body.amountAvailable,
          body.rebateAmount,
          body.rewardAmount,
          c.reliefAmount,
          c.relief_amount,
          c.amount
        ), 0),
        promoStatus: disabled && promoStatus === 'not_receive' ? '' : (promoStatus || '')
      }
    },
    preserveReadStateOnUnavailable(res, disableClaim = false) {
      this.readError = this.failMessage(res, this.$lang.network_error || 'Data is temporarily unavailable. Please try again later.')
      if (disableClaim && this.info && this.info.promoStatus === 'not_receive') {
        this.info = {
          ...this.info,
          promoStatus: ''
        }
      }
      this.$toast({
        message: this.readError,
        icon: 'cross'
      })
    },
    hasRewardWriteProof(res) {
      if (this.hasRewardUnavailableMarker(res)) return false
      const stack = [responseContent(res), res]
      for (let i = 0; i < stack.length && i < 50; i++) {
        const body = stack[i]
        if (!body || typeof body !== 'object') continue
        if (Array.isArray(body)) {
          body.forEach((value) => {
            if (value && typeof value === 'object') stack.push(value)
          })
          continue
        }
        const proofs = [
          body.writeProof,
          body.write_proof,
          body.affectedProof,
          body.affected_proof,
          body.affectedRowsProof,
          body.affected_rows_proof,
          body.count,
          body.serverProof,
          body.server_proof,
          body.serverRewardProof,
          body.server_reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (proofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === false || value === 0 || token === 'false' || token === '0' || token === 'fail' || token === 'failed'
        })) return false
        const positiveProofs = [
          body.rewardProof,
          body.reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (positiveProofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === true || value === 1 || token === 'true' || token === '1' || token === 'success' || token === 'ok'
        })) return true
        const recordProofs = [
          body.recordNo,
          body.record_no,
          body.recordId,
          body.record_id,
          body.rewardRecordNo,
          body.reward_record_no,
          body.rewardRecordId,
          body.reward_record_id,
          body.receiveRecordNo,
          body.receive_record_no,
          body.receiveRecordId,
          body.receive_record_id,
          body.claimRecordNo,
          body.claim_record_no,
          body.claimRecordId,
          body.claim_record_id
        ]
        const hasRecordProof = recordProofs.some((value) => {
          if (value && typeof value === 'object') return false
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && !['true', '1', 'success', 'ok', 'false', '0', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder', 'mock', 'mockmode', 'mock_mode', 'mockfallback', 'mock_fallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'readonly', 'readonlymode', 'read_only', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readonlyaction', 'read_only_action', 'writeblocked', 'write_blocked', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'falseproof', 'false_proof', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalerror', 'technical_error', 'unimplemented', 'notimplemented', 'not_implemented', 'notsupported', 'not_supported'].includes(token)
        })
        const aliasProofs = [
          body.serverRewardProof,
          body.server_reward_proof
        ]
        if (hasRecordProof && aliasProofs.some((value) => {
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return value === true || value === 1 || token === 'true' || token === '1' || token === 'success' || token === 'ok'
        })) return true
        const concreteProofs = [
          body.rewardProof,
          body.reward_proof,
          body.serverRewardProof,
          body.server_reward_proof,
          body.rewardIssueProof,
          body.reward_issue_proof
        ]
        if (concreteProofs.some((value) => {
          if (value && typeof value === 'object') return false
          const token = String(value == null ? '' : value).trim().toLowerCase()
          return token && !['true', '1', 'success', 'ok', 'false', '0', 'fail', 'failed', 'none', 'null', 'undefined', 'placeholder', 'mock', 'mockmode', 'mock_mode', 'mockfallback', 'mock_fallback', 'stub', 'fallback', 'fallbackused', 'fallback_used', 'readonly', 'readonlymode', 'read_only', 'read_only_mode', 'readonlyreward', 'read_only_reward', 'readonlyaction', 'read_only_action', 'writeblocked', 'write_blocked', 'paymentstatusunconfirmed', 'payment_status_unconfirmed', 'unconfirmed', 'backendblocked', 'backend_blocked', 'rewardbackendblocked', 'reward_backend_blocked', 'falseproof', 'false_proof', 'readunavailable', 'read_unavailable', 'routeunavailable', 'route_unavailable', 'technicalerror', 'technical_error', 'unimplemented', 'notimplemented', 'not_implemented', 'notsupported', 'not_supported'].includes(token)
        })) return true
        ;['content', 'payload', 'extra', 'page', 'data', 'body', 'meta', 'trace', 'diagnostics', 'diagnostic', 'detail', 'details'].forEach((key) => {
          const value = body[key]
          if (value && typeof value === 'object') stack.push(value)
        })
      }
      return false
    },
    hasExplicitRewardSuccess(res) {
      const c = responseContent(res)
      return [
        c.receiveSuccess,
        c.claimSuccess,
        c.signSuccess,
        c.paySuccess,
        c.success,
        c.received,
        c.claimed,
        c.signed
      ].some(value => value === true || value === 1 || ['1', 'true', 'success', 'ok'].includes(String(value == null ? '' : value).trim().toLowerCase()))
    },
    isReceiveSuccess(res) {
      return !this.hasRewardUnavailableMarker(res) && rewardClaimSuccess(res) && this.hasExplicitRewardSuccess(res) && (hasRewardIssueProof(res) || this.hasRewardWriteProof(res)) && this.hasRewardWriteProof(res)
    },
    async getJl() {
      if (this.claiming) return
      if (!this.token) {
        this.requireLogin()
        return
      }
      this.claiming = true
      try {
        const data = await ReceivePromoReliefAmount()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (this.hasRewardUnavailableMarker(data)) {
          this.$toast({
            message: this.failMessage(data),
            icon: 'cross'
          })
        } else if (this.isReceiveSuccess(data)) {
          this.$toast({
            message: this.$lang.bonus_txt16,
            icon: 'success'
          })
          this.GetPromoDailyRelief()
        } else {
          this.$toast({
            message: this.failMessage(data),
            icon: 'cross'
          })
        }
      } catch (e) {
        this.$toast({
          message: this.failMessage(e, this.$lang.network_error || 'Data is temporarily unavailable. Please try again later.'),
          icon: 'cross'
        })
      } finally {
        this.claiming = false
      }
    },
    async GetPromoDailyRelief() {
      if (!this.token) {
        this.requireLogin()
        return
      }
      this.loading = true // 开始加载
      try {
        const data = await GetPromoDailyRelief()
        if (this.isRewardNeedLogin(data)) {
          this.requireLogin()
        } else if (this.hasBlockingReadFailureMarker(data)) {
          this.readError = this.failMessage(data, this.$lang.network_error || 'Data is temporarily unavailable. Please try again later.')
          this.$toast({
            message: this.readError,
            icon: 'cross'
          })
        } else if (this.isReadableInitResponse(data)) {
          const content = responseContent(data)
          this.InitDate = this.normalizedRuleList(content)
          this.info = this.normalizeInfo(content, data)
          this.readError = ''
        } else if (this.hasRewardUnavailableMarker(data)) {
          const statusToken = String(this.firstValue(data && data.status, data && data.state, data && data.result, data && data.code, data && data.errorCode) || '').trim().toLowerCase()
          this.preserveReadStateOnUnavailable(data, statusToken !== 'read_failure')
        } else {
          this.readError = this.failMessage(data, this.$lang.network_error || 'Data is temporarily unavailable. Please try again later.')
          this.$toast({
            message: this.readError,
            icon: 'cross'
          })
        }
      } catch (e) {
        this.readError = this.failMessage(e, this.$lang.network_error || 'Data is temporarily unavailable. Please try again later.')
        this.$toast({
          message: this.readError,
          icon: 'cross'
        })
      } finally {
        this.loading = false // 加载结束
      }
    }
  }
}
</script>
<style lang="less" scoped>
.content-c {
  padding: 0% 3% 10% 3%;
  padding-top: 5px;
}
.read-error {
  margin-top: 8px;
  color: #f56c6c;
  font-size: var(--vk-fs-xs);
  line-height: 16px;
  text-align: center;
}
.content-c--c {
  margin-top: 10px;
  position: relative;
  border-radius: 15px;
  width: 100%;
  background: @cont-bg;
  height: 165px;
  border: 1px solid @info2-color;
  padding-bottom: 5px;
}
.content-c--c1 {
  position: absolute;
  font-size: var(--vk-fs-xl);
  left: 6%;
  top: 18%;
  font-weight: bold;
  line-height: 20px;
}
.content-c--c2 {
  position: absolute;
  left: 6%;
  top: 41%;
  font-weight: bold;
  font-size: var(--vk-fs-15);
}
.active {
  // box-shadow: 0 4px 1px #4a4a4a !important; /* 阴影效果 */
  background: #9b9b9b !important;
  border-bottom: 0px solid #494949 !important;
}
.custom-button {
  opacity: 1;
  position: absolute;
  margin-top: 15px;
  width: 130px;
  height: 38px;
  left: 6%;
  bottom: 12%;
  border-radius: 13px;
}
.content-c--c5 {
  position: absolute;
  right: 1%;
  width: 106px;
  bottom: 2px;

}
.content-c2 {
  font-size: var(--vk-fs-md);
  margin-top: 18px;
  background: #076237;
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 260px; /* 或者指定具体的宽度 */
  padding: 2px 10px;
  font-weight: bold;
}
.content-c3--t {
  margin-top: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 3.2% 12% 3.2% 19%;
  background: @cont-bg;
  border-radius: 10px 10px 0 0;
}
.content-c3--t2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 11% 10px 6%;
  background: @cont-bg;
}

.content-c3 :last-child {
  border-radius: 0 0 12px 12px !important;
}
.content-c3--t2 p {
  width: 40%;
  text-align: center;
}
.content-c3--t3 {
  // border-radius: 0 0 15px 15px;
  height: 0px;
  // background: @cont-bg;
}
.content-c4 {
  font-size: var(--vk-fs-md);
  margin-top: 18px;
  // background: #076237;
  background-size: 100% 100%; /* 宽度和高度都拉伸到 100% */
  background-repeat: no-repeat; /* 防止图片重复 */
  width: 260px; /* 或者指定具体的宽度 */
  padding: 2px 2px;
  font-weight: bold;
}

/* PC 端样式 */
@media (min-width: 769px) {
  .content-c3--t {
    padding: 3.2% 65px 3.2% 79px;
  }
}
</style>
